var amt_admin = require('amt_admin').default;
var app = require('angular').module('ww2_analytics.purchases_by_product_key', [amt_admin]);

export default app.name;
